import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import DescriptionIcon from '@mui/icons-material/Description';
import SourceIcon from '@mui/icons-material/Source';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


import Reporting from '../Reporting/Reporting';
import Filing26Q from './Purchase/TDS_Payables_Reconciliation/form26QFiling';
import Filing24Q from './Purchase/TDS_Payables_Reconciliation/form24QFiling';
import FilingCards from './FilingCards';

const toggleButtonStyle = {
    flex: 1,
    border: 0,
    borderRadius: '30px',
    textTransform: 'none',
    px: 3,
    py: 1,
    fontWeight: 600,
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    '&.Mui-selected': {
        backgroundColor: 'var(--main-btn-color)',
        color: '#ffffff',
    },
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '&.Mui-selected:hover': {
        backgroundColor: 'var(--main-btn-color)',
    },
};

export default function ArcFiling() {
    const history = useHistory();
    const location = useLocation();

    const [alignment, setAlignment] = useState('gst');
    const [tabIndex, setTabIndex] = useState(0);
    const [sitemapData, setSitemapData] = useState(null);

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, [location.pathname]);

    const salesAccess = sitemapData?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    const gstFilingTabs = [
        salesAccess.includes("FILLING") && {
            label: 'GSTR-1',
            icon: <DescriptionIcon />,
            path: '/Reporting',
            component: Reporting
        },

    ].filter(Boolean);

    const tdsFilingTabs = [
        purchaseAccess.includes("26Q FILLING") && {
            label: '26Q',
            icon: <DescriptionIcon />,
            path: '/26QFiling',
            component: Filing26Q
        },
        purchaseAccess.includes("24Q FILLING") && {
            label: '24Q',
            icon: <DescriptionIcon />,
            path: '/24QFiling',
            component: Filing24Q
        },
    ].filter(Boolean);

    const allFilingPaths = [...gstFilingTabs, ...tdsFilingTabs].map(tab => tab.path);
    const isOnSpecificFiling = allFilingPaths.includes(location.pathname);
    const isOnMainFilingPage = location.pathname === '/Filing';

    useEffect(() => {
        if (isOnSpecificFiling) {
        const currentPath = location.pathname;
        const gstIndex = gstFilingTabs.findIndex(tab => tab.path === currentPath);
        const tdsIndex = tdsFilingTabs.findIndex(tab => tab.path === currentPath);

            if (gstIndex !== -1) {
            setAlignment('gst');
            setTabIndex(gstIndex);
            } else if (tdsIndex !== -1) {
            setAlignment('tds');
            setTabIndex(tdsIndex);
            }
        }
    }, [location.pathname, isOnSpecificFiling]);

    const tabsToShow = alignment === 'gst' ? gstFilingTabs : tdsFilingTabs;

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== alignment) {
            setAlignment(newAlignment);
            const newTabs = newAlignment === 'gst' ? gstFilingTabs : tdsFilingTabs;
            if (!newTabs.length) return;
            setTabIndex(0);
            history.push(newTabs[0].path);
        }
    };

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        const selectedTab = tabsToShow[newValue];
        if (selectedTab?.path) {
            history.push(selectedTab.path);
        }
    };

    const activeTab = [...gstFilingTabs, ...tdsFilingTabs].find(tab => tab.path === location.pathname);
    const ActiveComponent = activeTab?.component;

    if (isOnMainFilingPage || !isOnSpecificFiling) {
        return <FilingCards />;
    }

    return (
        <Box sx={{ fontFamily: "'Inter', sans-serif", width: '100%' }}>
                    <ActiveComponent />
        </Box>
    );
}